import React from 'react';
import { Field, FieldProps, getIn } from 'formik';
import { Publication } from '@/types/core/Publication';
import { Flex, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';
import FormikDownshiftSelect from '@components/app/form/select/FormikDownshiftSelect';
import PublicationCombobox from '@components/app/form/select/PublicationCombobox';
import FormElement from '@components/presentational/Form/FormElement';

interface PublicationLinkedSelectProps {
  name: string;
  publicationId?: string;
  accentColor?: 'tournesol' | 'menthe' | 'tuile';
}
export function PublicationLinkedSelect({
  name,
  publicationId,
  accentColor,
}: PublicationLinkedSelectProps) {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const errors = getIn(form.errors, name);
        const touched = getIn(form.touched, name);
        const hasError = errors && touched;

        let errorsComponents = [];
        if (errors && errors.publication) {
          errorsComponents = errors.publication.map(errorItem => (
            <li key={errorItem}>{errorItem}</li>
          ));
        }

        const publicationApiFilters = () => {
          const filters: Record<string, string> = {
            linkableToPublication: '',
            notPublicationIds: field.value
              .filter(
                publication =>
                  typeof publication !== 'undefined' && publication !== null
              )
              .map(publication => publication.id)
              .join(','), // Convert array of IDs to a comma-separated string
          };

          if (publicationId) {
            filters.notPublicationIds +=
              (filters.notPublicationIds ? ',' : '') + publicationId;
          }

          if (!filters.notPublicationIds) {
            delete filters.notPublicationIds;
          }

          return filters;
        };

        const onPublicationRemoved = (publication: Publication) => {
          field.onChange(name)(
            field.value.filter(
              publicationToRemove => publicationToRemove.id !== publication.id
            )
          );
        };

        const onPublicationSelected = (publication: Publication) => {
          field.onChange(name)([...field.value, publication]);
        };

        return (
          <>
            {/*{JSON.stringify(getIn(form.errors, name)['publication'])}*/}
            <FormElement isInvalid={hasError} errorMessage={errorsComponents}>
              <FormikDownshiftSelect
                name={'publication'}
                SelectComponent={PublicationCombobox}
                id={'publication'}
                accentColor={accentColor}
                fields={{
                  publication: 'title',
                  user: 'displayName',
                  group: 'name,private',
                }}
                filters={publicationApiFilters()}
                allowClear={false}
                onChange={value => {
                  if (!value) {
                    return;
                  }
                  onPublicationSelected(value.item);
                }}
              />
              {field.value.map((publication: Publication) => (
                <Flex
                  direction="column"
                  mt="0.5rem"
                  gap="0.25rem"
                  key={publication.id}
                >
                  <Tag
                    key={publication.id}
                    bg="tournesol.25"
                    padding="0.25rem 0.5rem"
                    display="flex"
                    justifyContent="space-between"
                  >
                    <TagLabel>{publication.title}</TagLabel>
                    <TagCloseButton
                      onClick={() => onPublicationRemoved(publication)}
                    />
                  </Tag>
                </Flex>
              ))}
            </FormElement>
          </>
        );
      }}
    </Field>
  );
}
